import { Button } from '@dev-spendesk/grapes';
import { useEffect, useState } from 'react';

import { TopBanner } from 'common/components/TopBanner/TopBanner';
import { useFeature } from 'common/hooks/useFeature';
import { useTranslation } from 'common/hooks/useTranslation';
import { useCompany } from 'modules/app/hooks/useCompany';
import { useUserRoles } from 'modules/app/hooks/useUserRoles';
import { useFetchKycRemediation } from 'modules/invoices/hooks/useFetchKycRemediation';
import { isEeaMember } from 'src/core/config/country';
import FEATURES from 'src/core/constants/features';
import { LocalStorageKey } from 'src/core/constants/storage';
import { AnalyticEventName, track } from 'src/core/utils/analytics';

export const InternationalWireTransferAccountValidationTopBanner = () => {
  const { t } = useTranslation('global');
  const company = useCompany();
  const { isAccountOwner } = useUserRoles();
  const isEEAOrEUROCurrency =
    company.currency === 'EUR' || isEeaMember(company.country);
  const isEeaInternationalTransfersEnabled = useFeature(
    FEATURES.TMP_EEA_INTERNATIONAL_WIRE_TRANSFER,
  );
  const hasBeenClosed = localStorage.getItem(
    LocalStorageKey.IwtRemediateTopBannerClosed,
  );
  const fetchKycRemediationResult = useFetchKycRemediation({
    isEnabled:
      isAccountOwner &&
      isEeaInternationalTransfersEnabled &&
      isEEAOrEUROCurrency &&
      !hasBeenClosed,
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (
      fetchKycRemediationResult.status === 'success' &&
      fetchKycRemediationResult.data.status === 'draft'
    ) {
      setIsOpen(true);
    }
  }, [fetchKycRemediationResult]);

  const openKycAndCloseBanner = () => {
    // should always be true here because we don't show the banner if the status is not 'success'
    if (fetchKycRemediationResult.status === 'success') {
      window.open(fetchKycRemediationResult.data.onboardingUrl, '_blank');
      track(
        AnalyticEventName.SETTINGS_PAYMENT_METHODS_IWT_KYC_REMEDIATION_OPENED,
        { source: 'AO Header Notif' },
      );
    }
    setIsOpen(false);
    localStorage.setItem(LocalStorageKey.IwtRemediateTopBannerClosed, 'true');
  };

  if (!isOpen) {
    return null;
  }

  return (
    <TopBanner
      variant="complementary"
      testId="missing-kyc-information-banner"
      title={t('international-wiretransfer.topNotif')}
    >
      <Button
        variant="secondaryNeutral"
        text={t('international-wiretransfer.accountValidationModal.reviewCta')}
        onClick={openKycAndCloseBanner}
      />
    </TopBanner>
  );
};
